import { render } from "./AccPurchase.vue?vue&type=template&id=5862bc18&scoped=true"
import script from "./AccPurchase.vue?vue&type=script&lang=js"
export * from "./AccPurchase.vue?vue&type=script&lang=js"

import "./AccPurchase.vue?vue&type=style&index=0&id=5862bc18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5862bc18"

export default script